// Keep in sync with app/lib/enums/distributor_scope.py
const DistributorScope = {
  ALL: 'all',
  PARTNERS: 'partners',
  INFLUENCE: 'influence',
};

const DistributorScopeTabs = [
  { value: DistributorScope.ALL, label: 'All' },
  { value: DistributorScope.PARTNERS, label: 'Partners' },
  { value: DistributorScope.INFLUENCE, label: 'Influence' },
];

const DistributorScopeSubtitle = {
  [DistributorScope.ALL]: 'All Distributors',
  [DistributorScope.PARTNERS]: 'Distributor Partners',
  [DistributorScope.INFLUENCE]: 'Influence DPs',
};

export { DistributorScope, DistributorScopeTabs, DistributorScopeSubtitle };
